var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.80001C11.5582 6.80001 11.2 6.44184 11.2 6.00001C11.2 5.55818 11.5582 5.20001 12 5.20001H12.8C14.5673 5.20001 16 6.6327 16 8.40001V14.8C16 16.5673 14.5673 18 12.8 18H3.2C1.43269 18 0 16.5673 0 14.8V8.39446C0 6.62715 1.43269 5.19446 3.2 5.19446H4C4.44183 5.19446 4.8 5.55263 4.8 5.99446C4.8 6.43629 4.44183 6.79446 4 6.79446H3.2C2.31634 6.79446 1.6 7.5108 1.6 8.39446V14.8C1.6 15.6837 2.31634 16.4 3.2 16.4H12.8C13.6837 16.4 14.4 15.6837 14.4 14.8V8.40001C14.4 7.51636 13.6837 6.80001 12.8 6.80001H12Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46967 0.234315C7.76256 -0.0781049 8.23744 -0.0781049 8.53033 0.234315L10.7803 2.63431C11.0732 2.94673 11.0732 3.45327 10.7803 3.76569C10.4874 4.07811 10.0126 4.07811 9.71967 3.76569L8.798 2.782L8.8 2.8V10.8C8.8 11.2418 8.44183 11.6 8 11.6C7.55817 11.6 7.2 11.2418 7.2 10.8V2.8C7.2 2.7949 7.20005 2.78982 7.20014 2.78474L6.28033 3.76569C5.98744 4.07811 5.51256 4.07811 5.21967 3.76569C4.92678 3.45327 4.92678 2.94673 5.21967 2.63431L7.46967 0.234315Z",
    fill: "currentcolor"
  })));
};
export default SvgShare;